<div class="modal-header bg-dark">
    <h4 class="modal-title">Assegnazione <strong>Prenotazione</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<form #inspectionAssignForm="ngForm" role="form" class="form-horizontal form-validation">
    <div class="modal-body row">
        <div class="col-md-2 col-md-offset-2"><p><strong>ORDINATIVI:</strong></p></div>
        <div class="col-md-6"><p *ngFor="let inspectionOrder of inspectionOrders">{{ inspectionOrder.number }}</p></div>
        <div class="col-md-8 col-md-offset-2">
            <div class="form-group">
                <label for="inspector">Seleziona Ispettore:</label>
                <select class="form-control"
                        name="inspector"
                        id="inspector"
                        style="width:100%;"
                        required
                        [(ngModel)]="idInspectorToAssign">
                    <option [ngValue]="" disabled selected>Seleziona Ispettore...</option>
                    <option *ngFor="let userInspector of userInspectors" [ngValue]="userInspector.id_user">{{ userInspector.name + ' ' + userInspector.surname }}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit"
                [disabled]="!inspectionAssignForm.form.valid"
                class="btn btn-embossed btn-primary"
                (click)="passBack()">
            <i class="icons-office-01"></i> Assegna Ispezione
        </button>
        <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
    </div>
</form>
